export default __webpack_public_path__ + "static/illica-c0a376a189d15415914d6563d0211491.jpg";